import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "up-load" }
const _hoisted_2 = { class: "up-one" }
const _hoisted_3 = { class: "up-one" }
const _hoisted_4 = { class: "property" }
const _hoisted_5 = { class: "up-one" }
const _hoisted_6 = { class: "property" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UPLOADING = _resolveComponent("UPLOADING")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_codeEditor = _resolveComponent("codeEditor")!
  const _component_vxe_table_column = _resolveComponent("vxe-table-column")!
  const _component_vxe_table = _resolveComponent("vxe-table")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_UPLOADING, {
      ref: "parent",
      title: "模拟自定义上传",
      count: 0,
      value: {}
    }, null, 512),
    _createVNode(_component_el_button, {
      style: {"width":"200px","margin":"10px auto","display":"block"},
      class: "theme-all",
      onClick: _ctx.up
    }, {
      default: _withCtx(() => _cache[0] || (_cache[0] = [
        _createTextVNode("确认上传")
      ])),
      _: 1
    }, 8, ["onClick"]),
    _createElementVNode("div", _hoisted_1, [
      _cache[6] || (_cache[6] = _createElementVNode("hr", null, null, -1)),
      _cache[7] || (_cache[7] = _createElementVNode("div", { class: "up-title" }, "使用说明", -1)),
      _createElementVNode("div", _hoisted_2, [
        _cache[1] || (_cache[1] = _createTextVNode("1、导入上传组件，并挂载上传组件：")),
        _createVNode(_component_codeEditor, { value: "import UPLOADING from \"@/components/uploading/uploading.vue\"; \r\ncomponents: { UPLOADING },\r\n            " })
      ]),
      _createElementVNode("div", _hoisted_3, [
        _cache[2] || (_cache[2] = _createTextVNode("2、导入上传组件，并挂载上传组件：")),
        _createVNode(_component_codeEditor, { value: " <UPLOADING ref=\"parent\"title=\"模拟自定义上传\":count=\"0\":value=\"{}\"></UPLOADING>\"; " })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _cache[3] || (_cache[3] = _createElementVNode("div", null, "属性说明", -1)),
        _createVNode(_component_vxe_table, {
          align: _ctx.allAlign,
          data: _ctx.call
        }, {
          default: _withCtx(() => [
            _createVNode(_component_vxe_table_column, {
              field: "name",
              title: "属性名"
            }),
            _createVNode(_component_vxe_table_column, {
              field: "class",
              title: "类型"
            }),
            _createVNode(_component_vxe_table_column, {
              field: "default",
              title: "默认值"
            }),
            _createVNode(_component_vxe_table_column, {
              field: "effect",
              title: "作用"
            }),
            _createVNode(_component_vxe_table_column, {
              field: "detail",
              title: "详细"
            })
          ]),
          _: 1
        }, 8, ["align", "data"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _cache[4] || (_cache[4] = _createTextVNode("3、通过调用子组件：parent方法触发")),
        _createVNode(_component_codeEditor, { value: " let { child, isEmpty, stop } = parent.value.parent(); " })
      ]),
      _createElementVNode("div", _hoisted_6, [
        _cache[5] || (_cache[5] = _createElementVNode("div", null, "回调说明", -1)),
        _createVNode(_component_vxe_table, {
          align: _ctx.allAlign,
          data: _ctx.property
        }, {
          default: _withCtx(() => [
            _createVNode(_component_vxe_table_column, {
              field: "name",
              title: "回调名字"
            }),
            _createVNode(_component_vxe_table_column, {
              field: "class",
              title: "类型"
            }),
            _createVNode(_component_vxe_table_column, {
              field: "effect",
              title: "作用"
            }),
            _createVNode(_component_vxe_table_column, {
              field: "detail",
              title: "详细"
            })
          ]),
          _: 1
        }, 8, ["align", "data"])
      ]),
      _cache[8] || (_cache[8] = _createElementVNode("div", { style: {"text-align":"center","width":"100%"} }, [
        _createElementVNode("a", {
          href: "https://element-plus.gitee.io/#/zh-CN/component/upload",
          target: "_blank",
          rel: "noopener noreferrer"
        }, "更多上传示例/文档")
      ], -1)),
      _cache[9] || (_cache[9] = _createElementVNode("div", { style: {"color":"red","text-align":"center"} }, "上传的axios已封装在组件@/components/uploading/uploading.vue中，可在里面搜：upApi 即可", -1))
    ])
  ]))
}